import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
const FONT_SIZE = 50;
export default class LinkCell {
    constructor(x, y, index, reelIndex) {
        this.EXIT_MAP = {
            12: "animation_exit", // simbolo normale con animazione di exit (non jackpot)
            13: "mini_exit",
            14: "minor_exit",
            15: "major_exit",
            16: "grand_exit",
            17: "animation_exit",
            18: "x2_exit",
            19: "x3_exit"
        };
        this.WIN_MAP = {
            12: "animation_win", // simbolo normale con animazione di win (non jackpot)
            13: "mini_win",
            14: "minor_win",
            15: "major_win",
            16: "grand_win",
            17: "animation_win",
            18: "x2_win",
            19: "x3_win"
        };
        this.memo = 0;
        this.isStopped = false;
        this.x = x;
        this.y = y;
        this.index = index;
        this.reelIndex = reelIndex;
        this.linkSpinSymbolSpineRaw = ResourcesDispatcher.GAME_CONSTANTS.linkSymbolSpines;
        let cellGeom = layoutBuilder.getNodeByPath(`LinkSpin/grid/reels/reel_${reelIndex}/cell_${index}/cell#geom`);
        this.linkSpinSymbolSpines = [];
        for (let i = 0; i < this.linkSpinSymbolSpineRaw.length; i++) {
            let spine = scene.add.spine(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.getLinkSpinSymbolSpineRaw(i).jsonKey, this.getLinkSpinSymbolSpineRaw(i).atlasKey)
                .setOrigin(cellGeom?.phaser.display?.originX, cellGeom?.phaser.display?.originY)
                .setVisible(false);
            this.linkSpinSymbolSpines.push(spine);
        }
        this.container = layoutBuilder.findByPath(`LinkSpin/grid/reels/reel_${reelIndex}/cell_${index}`);
        this.container.add(this.linkSpinSymbolSpines);
        let linkFont = globalVariableManager.getFont().overrideFont({ fontSize: FONT_SIZE, color: "#FFEE00" });
        this.linkSpinWinText = scene.add.text(0, 0, "", linkFont).setOrigin(0.5).setVisible(false);
        this.container.add(this.linkSpinWinText);
    }
    /** PUBLIC GETTERS **/
    getIndex() {
        return this.index;
    }
    getMemo() {
        return this.memo;
    }
    getContainer() {
        return this.container;
    }
    getSpine(memo) {
        return this.linkSpinSymbolSpines[memo];
    }
    getCurrentSpine() {
        return this.linkSpinSymbolSpines[this.memo];
    }
    getLinkSpinWinText() {
        return this.linkSpinWinText;
    }
    /*******************/
    /** PUBLIC SETTERS **/
    setIndex(index) {
        this.index = index;
    }
    setMemo(memo) {
        this.memo = memo;
    }
    setCellInfo(cellMemo) {
        this.linkSpinSymbolSpines.forEach((spine) => {
            spine.setVisible(false);
        });
        this.getSpine(cellMemo).setVisible(true);
        this.getSpine(cellMemo).animationState.clearTrack(0);
        this.getSpine(cellMemo).skeleton.setToSetupPose();
        this.setMemo(cellMemo);
        return this;
    }
    setLinkSpinWinText(value) {
        this.multValue = value;
        if (!this.canShowLinkValueText()) {
            this.cleanLinkValueText();
            return;
        }
        const formattedValue = Utils.formatValue(value);
        Utils.digitCountAndResizeFont(formattedValue, 3, this.linkSpinWinText, FONT_SIZE, 5);
        Utils.digitCountAndResizeFont(formattedValue, 4, this.linkSpinWinText, FONT_SIZE, 15);
        this.linkSpinWinText.setText(formattedValue).setAlpha(1).setVisible(true);
    }
    /*******************/
    resetPosition() {
        this.container.setPosition(this.x, this.y);
    }
    refreshInternalPositions() {
        const cellGeom = layoutBuilder.getNodeByPath(`LinkSpin/grid/reels/reel_${this.reelIndex}/cell_${this.index}/cell#geom`);
        if (!cellGeom)
            return;
        const x = cellGeom.phaser?.display?.x ?? 0;
        const y = cellGeom.phaser?.display?.y ?? 0;
        const originX = cellGeom.phaser?.display?.originX ?? 0.5;
        const originY = cellGeom.phaser?.display?.originY ?? 0.5;
        this.linkSpinSymbolSpines.forEach(spine => spine.setPosition(x, y).setOrigin(originX, originY));
        this.linkSpinWinText.setPosition(x, y).setOrigin(originX, originY);
    }
    /** PRIVATE GETTERS **/
    getLinkSpinSymbolSpineRaw(memo) {
        return this.linkSpinSymbolSpineRaw[memo];
    }
    /*******************/
    playAnimation(animationName, loop = false) {
        return new Promise((resolve) => {
            const memo = this.getMemo();
            // Spine principale (animazione 0)
            const mainSpine = this.getSpine(memo);
            const mainAnimations = this.getLinkSpinSymbolSpineRaw(memo).animations;
            const selectedAnimation = mainAnimations.includes(animationName) ? animationName : null;
            if (!mainSpine || !mainAnimations || !selectedAnimation) {
                return resolve(true);
            }
            mainSpine.setVisible(true);
            //-----------------------------------------
            // 1) RIPRODUCO L'ANIMAZIONE RICHIESTA (fallback alla prima disponibile)
            //-----------------------------------------
            const baseEntry = mainSpine.animationState.addAnimation(0, selectedAnimation, false);
            if (baseEntry)
                baseEntry.alpha = 1;
            //-----------------------------------------
            // 2) SE IL SIMBOLO È 13 / 14 / 15 → AGGIUNGO OVERLAY
            //-----------------------------------------
            if (memo === 13 || memo === 14 || memo === 15 || memo === 16 || memo === 18 || memo === 19) {
                // Prendo lo spine overlay (ultimo della lista)
                const overlayIndex = this.linkSpinSymbolSpineRaw.length - 1;
                const overlaySpine = this.getSpine(overlayIndex);
                const overlayAnimations = this.getLinkSpinSymbolSpineRaw(overlayIndex).animations;
                if (overlaySpine && overlayAnimations) {
                    const overlayName = this.WIN_MAP[memo];
                    const overlayAnimIndex = overlayAnimations.indexOf(overlayName);
                    if (overlayAnimIndex !== -1) {
                        overlaySpine.setVisible(true);
                        const overlayEntry = overlaySpine.animationState.addAnimation(0, overlayAnimations[overlayAnimIndex], false);
                        if (overlayEntry)
                            overlayEntry.alpha = 1;
                        // mainSpine.setVisible(false); // nascondo il main spine quando parte l'overlay
                    }
                }
            }
            //-----------------------------------------
            // 3) Listener per concludere la Promise
            //-----------------------------------------
            if (!loop && baseEntry) {
                baseEntry.listener = {
                    complete: () => resolve(true)
                };
            }
            else {
                resolve(true);
            }
        });
    }
    playAnimation2(loop = false) {
        return new Promise((resolve) => {
            const memo = this.getMemo();
            const animationName = this.WIN_MAP[memo];
            // Spine principale (animazione 0)
            const mainSpine = this.getSpine(memo);
            const mainAnimations = this.getLinkSpinSymbolSpineRaw(memo).animations;
            const selectedAnimation = mainAnimations.includes(animationName) ? animationName : null;
            if (!mainSpine || !mainAnimations || !selectedAnimation) {
                return resolve(true);
            }
            mainSpine.setVisible(true);
            //-----------------------------------------
            // 1) RIPRODUCO L'ANIMAZIONE RICHIESTA (fallback alla prima disponibile)
            //-----------------------------------------
            const baseEntry = mainSpine.animationState.addAnimation(0, selectedAnimation, false);
            if (baseEntry)
                baseEntry.alpha = 1;
            //-----------------------------------------
            // 3) Listener per concludere la Promise
            //-----------------------------------------
            if (!loop && baseEntry) {
                baseEntry.listener = {
                    complete: () => resolve(true)
                };
            }
            else {
                resolve(true);
            }
        });
    }
    stopAnimation() {
        this.getSpine(this.getMemo()).animationState.clearTrack(0);
        this.getSpine(this.getMemo()).skeleton.setToSetupPose();
    }
    /**
     * Celebra la vincita di una singola cella nel LinkSpin
     * Viene chiamata una volta per ogni cella vincente
     */
    celebrateLinkWin(animationIndex) {
        return new Promise(async (resolve) => {
            // ✨ Reset della flag all'inizio di ogni celebrazione
            this.isStopped = false;
            this.celebrateLinkResolve = resolve;
            // Helper locale
            const checkStop = () => {
                if (this.isStopped || scene.linkSpinGameArea.isStoppingLinkWinCelebration) {
                    resolve(true);
                    return true;
                }
                return false;
            };
            const memo = this.getMemo();
            // ✨ Controlla se è stato richiesto lo stop dopo il delay
            if (checkStop())
                return;
            try {
                // Step 1: Delay iniziale basato sull'indice della cella
                await this.waitDelay(animationIndex * 1000);
                // ✨ Controlla se è stato richiesto lo stop dopo il delay
                if (checkStop())
                    return;
                // Step 2: Identifica se è un simbolo jackpot
                const isJackpot = memo === 13 || memo === 14 || memo === 15 || memo === 16 || memo === 18 || memo === 19;
                // ✨ Controlla PRIMA di fare lo shoot
                if (checkStop())
                    return;
                // Step 3: Fai lo shoot dell'animazione
                await animationManager.leftSideGridAnimation?.shoot();
                // ✨ Controlla SUBITO DOPO che shoot() completa
                if (checkStop())
                    return;
                // Step 4: Fai l'animazione di exit se è jackpot, altrimenti particella
                if (isJackpot) {
                    const exitAnim = this.EXIT_MAP[memo];
                    await this.playExitAnimation(exitAnim);
                }
                else {
                    // await this.playLinkSpinParticleAnimation();
                }
                // ✨ Controlla se è stato stoppato prima di finire
                if (checkStop())
                    return;
                // Step 5: Reset finale e aumento del box di vincita
                this.cleanLinkValueText();
                scene.linkSpinGameArea.increaseWinBoxValue(this.multValue);
                // this.background.setVisible(true);
                resolve(true);
            }
            catch (error) {
                // Se c'è un errore (ad es. timer cancellato), risolvi comunque
                console.warn("Celebrazione LinkWin interrotta:", error);
                resolve(true);
            }
        });
    }
    /**
     * Celebra la vincita di una singola cella nel LinkSpin
     * Viene chiamata una volta per ogni cella vincente
     */
    celebrateLinkWin2(animationIndex) {
        return new Promise(async (resolve) => {
            // ✨ Reset della flag all'inizio di ogni celebrazione
            this.isStopped = false;
            this.celebrateLinkResolve = resolve;
            // Helper locale
            const checkStop = () => {
                if (this.isStopped || scene.linkSpinGameArea.isStoppingLinkWinCelebration) {
                    resolve(true);
                    return true;
                }
                return false;
            };
            // ✨ Controlla se è stato richiesto lo stop dopo il delay
            if (checkStop())
                return;
            try {
                // Step 1: Delay iniziale basato sull'indice della cella
                await this.waitDelay(animationIndex * 1000);
                // ✨ Controlla se è stato richiesto lo stop dopo il delay
                if (checkStop())
                    return;
                // Step 4: Fai l'animazione di exit se è jackpot
                const exitAnim = this.EXIT_MAP[this.getMemo()];
                await this.playExitAnimation2(exitAnim);
                // ✨ Controlla se è stato stoppato prima di finire
                if (checkStop())
                    return;
                // Step 5: Reset finale e aumento del box di vincita
                this.cleanLinkValueText();
                scene.linkSpinGameArea.increaseWinBoxValue(this.multValue);
                resolve(true);
            }
            catch (error) {
                // Se c'è un errore (ad es. timer cancellato), risolvi comunque
                console.warn("Celebrazione LinkWin interrotta:", error);
                resolve(true);
            }
        });
    }
    /**
     * Ferma immediatamente la celebrazione di una cella
     */
    stopCelebrateLinkWin() {
        // ✨ Imposta flag per far uscire celebrateLinkWin() ai prossimi controlli
        this.isStopped = true;
        // Pulisci il testo del valore
        this.cleanLinkValueText();
        // Ferma il tween del valore se esiste
        if (this.linkSpinTextValueTween) {
            this.linkSpinTextValueTween.stop();
            this.linkSpinTextValueTween.remove();
            this.linkSpinTextValueTween.destroy();
            this.linkSpinTextValueTween = undefined;
        }
        // Ferma l'animazione spine del simbolo
        this.stopAnimation();
        // ✨ CRUCIALE: Risolvi la promise della celebrazione SUBITO
        // Questo fa sì che celebrateLinkWin() si risolva anche se è bloccata in await
        if (this.celebrateLinkResolve) {
            this.celebrateLinkResolve(true);
            this.celebrateLinkResolve = undefined;
        }
        // Cancella il timer in sospeso
        if (this.timerCelebrateLinkWin) {
            this.timerCelebrateLinkWin.destroy();
            this.timerCelebrateLinkWin = undefined;
        }
    }
    playExitAnimation(animation) {
        return new Promise(async (resolve) => {
            // await this.playLinkSpinParticleAnimation();
            const overlaySpineIndex = 19;
            const overlaySpine = this.getSpine(overlaySpineIndex);
            const animations = this.getLinkSpinSymbolSpineRaw(overlaySpineIndex).animations;
            if (!overlaySpine || !animations)
                return resolve(true);
            const animIndex = animations.indexOf(animation);
            if (animIndex === -1)
                return resolve(true);
            overlaySpine.animationState.clearTrack(1);
            const trackEntry = overlaySpine.animationState.addAnimation(1, animations[animIndex], false);
            if (trackEntry) {
                trackEntry.alpha = 1;
                trackEntry.timeScale = 2;
                trackEntry.listener = {
                    complete: () => {
                        overlaySpine.skeleton.setToSetupPose();
                        resolve(true);
                    }
                };
            }
            else {
                resolve(true);
            }
        });
    }
    playExitAnimation2(animation) {
        return new Promise((resolve) => {
            const currentMemo = this.getMemo();
            const exitSpine = this.getSpine(currentMemo);
            const animations = this.getLinkSpinSymbolSpineRaw(currentMemo)?.animations;
            if (!exitSpine || !animations) {
                resolve(true);
                return;
            }
            const selectedAnimation = animations.find((name) => name === animation);
            if (!selectedAnimation) {
                resolve(true);
                return;
            }
            exitSpine.setVisible(true).setAlpha(1);
            this.container.bringToTop(exitSpine);
            this.container.bringToTop(this.linkSpinWinText);
            exitSpine.animationState.clearTrack(0);
            exitSpine.skeleton.setToSetupPose();
            const trackEntry = exitSpine.animationState.setAnimation(0, selectedAnimation, false);
            if (!trackEntry) {
                resolve(true);
                return;
            }
            trackEntry.alpha = 1;
            trackEntry.listener = {
                complete: () => {
                    if ([12, 13, 14, 15, 16, 18, 19].includes(this.getMemo())) {
                        soundManager.play(ResourcesDispatcher.SOUNDS.EXPLOSION_STONE);
                    }
                    resolve(true);
                }
            };
        });
    }
    waitDelay(ms) {
        return new Promise(res => {
            this.timerCelebrateLinkWin = scene.time.delayedCall(ms, res);
        });
    }
    cleanLinkValueText() {
        this.linkSpinWinText.setFontSize(FONT_SIZE).setText("").setVisible(false);
    }
    // reset eventuale tween vecchio (se lo usavi ancora)
    startCoinSpin() {
        const memo = this.getMemo();
        const spine = this.getSpine(memo);
        if (!spine)
            return;
        // nascondi eventuali animazioni precedenti
        spine.animationState.clearTracks();
        // mostra solo questo spine (in caso alcuni fossero hidden)
        this.linkSpinSymbolSpines.forEach(s => s.setVisible(false));
        spine.setVisible(true);
        // verifica che l'animazione "anim" esista
        const animations = this.getLinkSpinSymbolSpineRaw(memo).animations;
        if (!animations || !animations.includes("rotation")) {
            console.warn(`LinkCell: anima "rotation" non trovata per memo: ${memo}`);
            return;
        }
        // ✨ avvia l'animazione "rotation" in loop infinito
        const trackentry = spine.animationState.setAnimation(0, "rotation", true);
        trackentry.timeScale = 2; // velocizza l'animazione
    }
    stopCoinSpin() {
        const memo = this.getMemo();
        const spine = this.getSpine(memo);
        if (!spine)
            return;
        // stop animazione
        spine.animationState.clearTrack(0);
        spine.skeleton.setToSetupPose();
    }
    showLinkCellValueText(value = this.multValue) {
        this.multValue = Number.isFinite(value)
            ? value
            : 0;
        if (!this.canShowLinkValueText() ||
            this.multValue <= 0) {
            this.cleanLinkValueText();
            return;
        }
        this.setLinkSpinWinText(this.multValue);
    }
    async incrementLinkCellValue(initialValue, finalValue) {
        const waitTime = 500; // Tempo di attesa in millisecondi prima di incrementare il valore
        const startValue = Number.isFinite(initialValue) ? initialValue : (Number.isFinite(this.multValue) ? this.multValue : 0);
        const endValue = Number.isFinite(finalValue) ? finalValue : startValue;
        //Ferma un eventuale vecchio tween.
        if (this.linkSpinTextValueTween) {
            this.linkSpinTextValueTween.stop();
            this.linkSpinTextValueTween.remove();
            this.linkSpinTextValueTween = undefined;
        }
        this.multValue = startValue;
        /*
        * Mini, Minor, Major, Grand, X2 e X3
        * non devono mostrare nessun testo.
        */
        if (!this.canShowLinkValueText()) {
            this.cleanLinkValueText();
            this.multValue = endValue;
            return true;
        }
        this.showLinkCellValueText(startValue);
        await Utils.wait(waitTime, scene);
        if (startValue === endValue) {
            this.multValue = endValue;
            this.setLinkSpinWinText(endValue);
            await Utils.wait(waitTime, scene);
            return true;
        }
        return new Promise((resolve) => {
            const incrementTween = scene.tweens.addCounter({
                from: startValue,
                to: endValue,
                duration: 2000,
                ease: "Linear",
                onUpdate: () => {
                    const tweenValue = incrementTween.getValue();
                    const currentValue = typeof tweenValue === "number"
                        ? Math.floor(tweenValue)
                        : startValue;
                    this.multValue = currentValue;
                    this.linkSpinWinText
                        .setVisible(true)
                        .setAlpha(1)
                        .setText(Utils.formatValue(currentValue));
                },
                onComplete: async () => {
                    this.multValue = endValue;
                    this.setLinkSpinWinText(endValue);
                    this.linkSpinTextValueTween = undefined;
                    await Utils.wait(waitTime, scene);
                    resolve(true);
                }
            });
            this.linkSpinTextValueTween =
                incrementTween;
        });
    }
    canShowLinkValueText() {
        const memo = this.getMemo();
        return (memo === ResourcesDispatcher.GAME_CONSTANTS.S_LINK ||
            memo === ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED);
    }
}
